import CardDiv from "modules/common/card-div/CardDiv";
import React from "react";
import { List, Typography } from "antd";
import { fourPlaceHolder } from "modules/utilities/utility";
import Background from "modules/common/Background";
import corner1 from "assets/img/illustrations/corner-4.png";
import { Card } from "react-bootstrap";
const { Text } = Typography;

function FromStatus({
  isLoading,
  allAuthDashBoardLeadStats
}) {
  return (
    <div className="d-flex gap-3 mt-3">

      <div className="flex-1">
        <CardDiv
          title={<div>Orders</div>}
          component={
            <div>
              <Background
                image={corner1}
                style={{
                  borderTopRightRadius: "0.375rem",
                  borderBottomRightRadius: "0.375rem",
                }}
              />
              {isLoading ? (
                fourPlaceHolder()
              ) : (
                <div>
                  <List
                    size="small"
                    style={{ maxHeight: 172, overflowY: "auto" }}
                  >
                    <List.Item key="total_orders">
                      <List.Item.Meta
                        title={<Text className="capitalize">Total Orders</Text>}
                      />
                      <Text>{allAuthDashBoardLeadStats.orders.total_orders}</Text>
                    </List.Item>
                  </List>
                </div>
              )}
            </div>
          }
        />
      </div>
      <div className="flex-1">
        <CardDiv
          title={<div>Revenue</div>}
          component={
            <div>
              <Background
                image={corner1}
                style={{
                  borderTopRightRadius: "0.375rem",
                  borderBottomRightRadius: "0.375rem",
                }}
              />
              {isLoading ? (
                fourPlaceHolder()
              ) : (
                <div>
                  <List
                    size="small"
                    style={{ maxHeight: 172, overflowY: "auto" }}
                  >
                    <List.Item key="total_orders">
                      <List.Item.Meta
                        title={<Text className="capitalize">Total Orders Value</Text>}
                      />
                      <Text>{allAuthDashBoardLeadStats.orders.total_order_value}</Text>
                    </List.Item>
                    <List.Item key="total_orders">
                      <List.Item.Meta
                        title={<Text className="capitalize">Avergae Orders Value</Text>}
                      />
                      <Text>{allAuthDashBoardLeadStats.orders.average_order_value}</Text>
                    </List.Item>
                  </List>
                </div>
              )}
            </div>
          }
        />
      </div>
      <div className="flex-1">
        <CardDiv
          title={<div>Void Orders</div>}
          component={
            <div>
              <Background
                image={corner1}
                style={{
                  borderTopRightRadius: "0.375rem",
                  borderBottomRightRadius: "0.375rem",
                }}
              />
              {isLoading ? (
                fourPlaceHolder()
              ) : (
                <div>
                  <List
                    size="small"
                    style={{ maxHeight: 172, overflowY: "auto" }}
                  >
                    <List.Item key="void_orders">
                      <List.Item.Meta
                        title={<Text className="capitalize">Void Orders</Text>}
                      />
                      <Text>{allAuthDashBoardLeadStats.orders.void_orders}</Text>
                    </List.Item>
                    <List.Item key="void_orders_value">
                      <List.Item.Meta
                        title={<Text className="capitalize">Void Orders Value</Text>}
                      />
                      <Text>{allAuthDashBoardLeadStats.orders.void_order_value}</Text>
                    </List.Item>
                  </List>
                </div>
              )}
            </div>
          }
        />
      </div>
    </div>
  );
}

export default FromStatus;
